module.exports = __webpack_public_path__ + "img/android-btn.54fa861a.png";